module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAUCAYAAABvVQZ0AAABYElEQVQ4ja3UPUsdQRTG8Z8KxiAELGwCGhQtkkpRSCzFRiQgAf0CgVRKilT5AHYKFnb2FhamSay0EURFUYuAoKlVSCAvdr6hHNwbNpu5l3vhPs3umT3znzMze56Guy8q6Qm6s+dPnOCqXH5jYqwZ77CDXzjEBr7iDz5jNAUrVtaHJbyoWO+DYuZb/EhVNozNKkGh19jC0yIszmUZrVWCSurBJ7TkYQtorxFU0ku8L8FeYSyRNIuJXBxnM4C1RO7H2FXAJsusGDe4nouPcYD9RG5bnGHARmreWFpDAeusE+xZwK7rBGsM2HmdYGcB26sTbC9gK2U+dqEjF8f742y8qMvo2ejNBuxiMJF0i6YKcUnz+BCV3WV/8E0iqTgxBTrFjFw7bWMqq6QWhUW9ybzuH9dYxDh+Vwk7yvry7wUWzXEVvZjD9zKQcNtp9ONb/kMl246F4lKe4xEuMteNHv1fuAfSyUCZ0lrUjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spot/unUse.png
// module id = dZWx
// module chunks = 1